angular.module('TetherApp').controller('EmailController', [
    '$anchorScroll',
    '$location',
    '$window',
    '$timeout',
    'emailService',
    'modelLockService',
    '$interval',
    '$mdDialog',
    function (
        $anchorScroll,
        $location,
        $window,
        $timeout,
        emailService,
        modelLockService,
        $interval,
        $mdDialog
    ) {

        let self = this;
        let redirectTo = '/experience/email';

        self.emailList = {};
        self.email = {};
        self.email.experience = {};
        self.email.experience.is_visible_on_campaign_dashboard = true;
        self.email.experience.can_be_sent_from_conversation = false;
        self.email.recipient_type_id = null;
        self.currentPage = 1;

        self.inputUsers = [];

        //Model Lock
        self.modelLock;
        self.experienceLockTimeRemainingDisplay;
        self.experienceLockTimeEndDisplay;
        self.experienceLockCountdown = undefined;

        self.init = function () {
            self.currentUsers = '';

            if (window.usersData != undefined) {
                self.inputUsers = window.usersData;
            }

            if (self.currentUsers != undefined) {
                if (self.currentUsers === parseInt(self.currentUsers, 10)) {
                    currentUsersArray = [];
                    currentUsersArray.push(self.currentUsers);
                } else {
                    currentUsersArray = self.currentUsers.split(",");
                }

                self.outputUsers = [];

                angular.forEach(self.inputUsers, function( value, key ) {
                    if(currentUsersArray.indexOf(value.id) != -1){
                        tempValue = value;
                        tempValue.ticked = true;

                        self.outputUsers.push(tempValue);
                    }
                }, self);

            }
            self.updateUsers();
        };

        self.index = function (page) {
            self.currentPage = page;
            emailService.indexEmail(self.currentPage)
                .then(onIndex, onError);
        };

        let onIndex = function (data) {
            self.emailList = data.data;
        };

        //START: SHOW SERVICE FUNCTIONS
        self.show = function (data) {
            self.email = JSON.parse(JSON.stringify(data));

            if (self.email.hasOwnProperty('has_access_code')) {
                self.email.has_access_code = (self.email.has_access_code == '1') ? true : false;
            }

            if (self.email.hasOwnProperty('has_merge_data')) {
                self.email.has_merge_data = (self.email.has_merge_data == '1') ? true : false;
            }

            if (self.email.experience.hasOwnProperty('can_be_sent_from_conversation')) {
                self.email.experience.can_be_sent_from_conversation = (self.email.experience.can_be_sent_from_conversation == '1') ? true : false;
            }

            self.getExperienceLock();
        };
        //END: SHOW SERVICE FUNCTIONS

        //START: STORE SERVICE FUNCTIONS
        self.store = function () {
            let tempEmail = self.email;

            if (tempEmail.hasOwnProperty('has_access_code')
                && tempEmail.has_access_code == false
                && tempEmail.hasOwnProperty('access_code_experience_id')) {
                delete self.email.access_code_experience_id;
            }

            emailService.storeEmail(tempEmail)
                .then(onStore, onError);
        };

        let onStore = function (data) {
            redirectToIndex();
        };
        //END: STORE SERVICE FUNCTIONS

        //START: UPDATE SERVICE FUNCTIONS
        self.update = function () {
            let tempEmail = self.email;

            emailService.updateEmail(tempEmail)
                .then(onUpdate, onError);
        };

        let onUpdate = function (data) {
            self.releaseExperienceLock();
            redirectToIndex();
        };
        //END: UPDATE SERVICE FUNCTIONS

        //START: DESTROY SERVICE FUNCTIONS
        self.delete = function (emailId) {
            if ($window.confirm(self.deleteText.replace(':id', emailId))) {
                emailService.deleteEmail(emailId)
                    .then(onDelete, onError);
            }
        };

        let onDelete = function (data) {
            redirectToIndex();
        };
        //END: DESTROY SERVICE FUNCTIONS

        //START: GENERAL SERVICE FUNCTIONS
        let onError = function (data) {
            $location.hash('top');
            $anchorScroll();
            self.errors = data.data.errors;
        };
        //END: GENERAL SERVICE FUNCTIONS

        let redirectToIndex = function () {
            $window.location.href = '/' + self.client_eid + redirectTo;
        };

        self.populateByUserIds = function () {
            let tempUsers = self.email.users_data;
            if (tempUsers != undefined && tempUsers != '') {
                tempUsers = tempUsers.split(",");
            }
            if (tempUsers != undefined && (self.outputUsers == undefined || self.outputUsers.length == 0)) {
                let tempInputUsers = self.inputUsers;
                self.outputUsers = [];

                for (let index in tempInputUsers) {
                    if (tempUsers.indexOf(tempInputUsers[index]['id'].toString()) !== -1) {
                        let tempObject = tempInputUsers[index];
                        tempObject.ticked = true;
                        self.outputUsers.push(tempObject);
                    }
                }
                self.updateUsers();
            }
        };

        self.updateUsers = function () {

            self.userIds = '';

            angular.forEach(self.outputUsers, function( value, key ) {
                if(self.userIds == '') {
                    self.userIds = self.userIds + value.id;
                } else {
                    self.userIds = self.userIds + ',' + value.id;
                }

            }, self);

            self.email.users_data = self.userIds;
        };

        //START: EXPERIENCE EDIT TIMER

        self.getExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.email.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.lock(lockData).then(initiateExperienceLock, onError);
        }

        self.extendExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.email.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.extend(lockData).then(initiateExperienceLock, onError);
        };

        self.releaseExperienceLock = function() {
            let lockData = {
                'type': 'editing',
                'model_id': self.email.experience.eid,
                'model_type': 'experience',
            };
            modelLockService.release(lockData);
        };

        let initiateExperienceLock = function(modelLock) {
            self.modelLock = modelLock;
            self.experienceLockTimeEndDisplay = self.DisplayTime(modelLock.lock_expired_at);
            self.initiateExperienceLockCountdown(modelLock.seconds_left);
        };

        self.initiateExperienceLockCountdown = function (seconds) {
            let then = Date.now() + seconds * 1000;
            if (angular.isDefined(self.experienceLockCountdown)) {
                $interval.cancel(self.experienceLockCountdown);
                self.experienceLockCountdown = undefined
            }
            self.experienceLockCountdown = $interval(function () {
                let secondsLeft = Math.round((then - Date.now()) / 1000);
                if (secondsLeft < 0) {
                    self.experienceLockTimeRemainingDisplay = '0:00';
                    redirectToIndex();
                    $interval.cancel(self.experienceLockCountdown);
                } else {
                    let minutes = Math.floor(secondsLeft / 60);
                    let remainderSeconds = secondsLeft % 60;
                    self.experienceLockTimeRemainingDisplay = minutes + ':' + (remainderSeconds < 10 ? '0' : '') + remainderSeconds;
                    if (secondsLeft === 300) {
                        self.showExtendLock();
                    }
                }
            }, 1000);
        };

        self.DisplayTime = function(timestamp) {
            let end = new Date(timestamp);
            let hour = end.getHours();
            let adjustedHour = hour > 12 ? hour - 12 : hour;
            let minutes = end.getMinutes();
            return adjustedHour + ':' + (minutes < 10 ? '0' : '') + minutes;
        };

        self.showExtendLock = function() {
            var confirm = $mdDialog.confirm()
                    .title('Would you like to extend experience lock?')
                    .textContent('User will be redirected to index page without saving when timer runs out.')
                    .ariaLabel('Timer Dialog')
                    .ok('Extend Lock')
                    .cancel('Close');
            $mdDialog.show(confirm).then(function() {
                self.extendExperienceLock();
            }, function() {
                // this is close
            });
        };
        //END: EXPERIENCE EDIT TIMER

    }
]);
